.pills-container {
  display: flex;
  flex-wrap: wrap;
  gap: 0.8rem;
  align-items: flex-start;
  margin-bottom: 1.6rem;
}

.pill {
  all: unset;
  display: inline-flex;
  align-items: center;
  padding: 0.6rem 0.8rem;
  border-radius: 0.4rem;
  border: 1px dashed var(--color-grayscale-manatee);
  background: transparent;
  color: var(--color-grayscale-manatee);
  font-size: 1.2rem;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  min-height: 2.4rem;
  box-sizing: border-box;

  &:hover {
    background: #2d2f35;
  }

  &[data-selected='true'] {
    border: 1px solid var(--color-secondary);
    background: #3670ff33;
    color: #fafafa;

    /* The selected hover sat inside `&:hover` in the styled version, so it has
       to stay hover-scoped rather than becoming a flat selected rule. */
    &:hover {
      background: #3670ff50;
    }
  }
}
